import { useQuery } from "@apollo/client";
import { getFragmentData, graphql } from "../gql";
import { OnboardingLiveCreationIntentFragment } from "./OnboardingLiveFragments.ts";

export const GetOnboardingLiveCreationIntentsQuery = graphql(`
  query getOnboardingLiveCreationIntents {
    getOnboardingLiveCreationIntents {
      ...OnboardingLiveCreationIntentItem
    }
  }
`);

export function useOnboardingLiveCreationIntents() {
  const { data, loading } = useQuery(GetOnboardingLiveCreationIntentsQuery, {
    fetchPolicy: "cache-and-network",
  });
  return {
    intents:
      getFragmentData(
        OnboardingLiveCreationIntentFragment,
        data?.getOnboardingLiveCreationIntents,
      ) ?? [],
    loading,
  };
}
